export const NumberOfPreviewLessonsForFreeCourse = 2;
